var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/BrowserGuard/BrowserGuard.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { isBrowserSupported } from '@sm/utils';
import { Modal } from '@wds/modal';
import { defineMessages, T, t } from '@sm/intl';
import { WebAssetsThemeWrapper } from '../../theme';
var COPY = defineMessages({
  DIALOG_HEADER: {
    id: 'BrowserGuard.DialogHeader',
    defaultMessage: "Your browser isn't supported",
    description: 'Header of a dialog displaying a message to the users that their browser is not supported.'
  },
  DIALOG_BODY: {
    id: 'BrowserGuard.DialogBody',
    defaultMessage: 'For more information please visit:',
    description: 'Text describing that more information on the issue will be available on the following link'
  },
  LINK_TEXT: {
    id: 'BrowserGuard.LinkText',
    defaultMessage: 'Supported Browsers',
    description: 'Text for a link directing the user to the Supported Browsers help page'
  }
});
var BrowserGuardDialog = function BrowserGuardDialog() {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "BrowserGuardDialog",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Modal, {
    show: true,
    dismissible: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    header: t(COPY.DIALOG_HEADER),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.DIALOG_BODY,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://help.surveymonkey.com/articles/en_US/kb/What-browser-versions-do-you-support",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.LINK_TEXT,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 17
    }
  })))))));
};

/**
 * Component for checking if the user browser is supported
 *
 * Basic usage example:
 * `<BrowserGuard />`
 *
 * The basic usage will check against the default supported browsers
 * as documented here: https://help.surveymonkey.com/articles/en_US/kb/What-browser-versions-do-you-support
 *
 * If the user's browser is not supported a modal window will be displayed to the user.
 *
 * Optionally one can provide a list of supported browsers via the supportedBrowsers prop.
 * Also, a different UI may be rendered if a children is passed to the component.
 */
var BrowserGuard = function BrowserGuard(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? /*#__PURE__*/React.createElement(BrowserGuardDialog, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 14
      }
    }) : _ref$children,
    supportedBrowsers = _ref.supportedBrowsers;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasVerified = _useState2[0],
    setHasVerified = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSupported = _useState4[0],
    setIsSupported = _useState4[1];
  useEffect(function () {
    if (window && !hasVerified) {
      setIsSupported(isBrowserSupported(window.navigator.userAgent, supportedBrowsers));
      setHasVerified(true);
    }
  }, [hasVerified, supportedBrowsers]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasVerified && !isSupported ? /*#__PURE__*/React.createElement("div", {
    "data-testid": "BrowserGuard",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 9
    }
  }, children) : null);
};
export default BrowserGuard;
//# sourceMappingURL=BrowserGuard.js.map